import { CalloutType } from "./types";
export const calloutTypeIcons = {
    [CalloutType.success]: "check-circle",
    [CalloutType.info]: "important-circle",
    [CalloutType.warning]: "important",
    [CalloutType.error]: "close-circle",
    [CalloutType.note]: "card-large",
    [CalloutType.decision]: "decision",
};
/**
 * A list of all callout types
 */
export const calloutTypes = [
    CalloutType.info,
    CalloutType.note,
    CalloutType.success,
    CalloutType.warning,
    CalloutType.error,
    CalloutType.decision,
];
export const calloutTitles = {
    // TODO: localize
    [CalloutType.success]: `Success`,
    [CalloutType.info]: `Info`,
    [CalloutType.warning]: `Warning`,
    [CalloutType.error]: `Error`,
    [CalloutType.note]: `Note`,
    [CalloutType.decision]: `Decision`,
};
// TODO: localize
export const removeCalloutTitle = `Delete`;
export const calloutColors = {
    [CalloutType.success]: "green",
    [CalloutType.info]: "blue",
    [CalloutType.warning]: "yellow",
    [CalloutType.error]: "red",
    [CalloutType.note]: "purple",
    [CalloutType.decision]: "grey",
};
